// ActionMenu.jsx
import { useState, useEffect, useRef } from "react";
import { CgMoreVerticalO } from "react-icons/cg";
import { useTheme } from "../../../../contexts/ThemeContext";

function ActionMenu({ rowData, onClick }) {
  const [open, setOpen] = useState(false);
  const { isDark } = useTheme();
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={menuRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={(e) => onClick(e)}
        style={{
          border: "none",
          background: "transparent",
          padding: "2px",
          cursor: "pointer",
          color: isDark ? "#fff" : "#000"
        }}
      >
        <CgMoreVerticalO size={18} />
      </button>

      {open && (
        <ul
          style={{
            position: "absolute",
            right: 0,
            top: "100%",
            marginTop: "4px",
            background: "white",
            border: "1px solid #ddd",
            borderRadius: "6px",
            listStyle: "none",
            padding: "4px 0",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            zIndex: 9999999,
            minWidth: "120px",
          }}
        >
          <li
            style={{ padding: "6px 12px", cursor: "pointer" }}
            onClick={() => alert("Ver detalhes de " + rowData.plate)}
          >
            Ver detalhes
          </li>
          <li
            style={{ padding: "6px 12px", cursor: "pointer" }}
            onClick={() => alert("Editar " + rowData.plate)}
          >
            Editar
          </li>
          <li
            style={{ padding: "6px 12px", cursor: "pointer", color: "red" }}
            onClick={() => alert("Remover " + rowData.plate)}
          >
            Remover
          </li>
        </ul>
      )}
    </div>
  );
}

export default ActionMenu;
